export const TARGET_NONE = 'NONE';
export const TARGET_WAITING = 'WAITING';
export const TARGET_DISCUSSING = 'DISCUSSING';
export const TARGET_NEXT_TOPIC = 'NEXT_TOPIC';
export const TARGET_NEXT_THEME = 'NEXT_THEME';
export const TARGET_QUIT = 'QUIT';

export const TARGETS = {
  [TARGET_NONE]: {
    label: 'Ожидает подтверждения',
    value: TARGET_NONE,
    color: 'danger',
  },
  [TARGET_WAITING]: {
    label: 'Онлайн',
    value: TARGET_WAITING,
  },
  [TARGET_DISCUSSING]: {
    label: 'Беседую',
    value: TARGET_DISCUSSING,
    color: 'success',
  },
  [TARGET_NEXT_TOPIC]: {
    label: 'Запрос на следующий вопрос',
    value: TARGET_NEXT_TOPIC,
    color: 'warning',
  },
  [TARGET_NEXT_THEME]: {
    label: 'Запрос на следующюю тему',
    value: TARGET_NEXT_THEME,
    color: 'warning',
  },
  [TARGET_QUIT]: {
    label: 'Вышел',
    value: TARGET_QUIT,
    color: 'secondary',
  },
};
